import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../Components/Styles/promo.css';

function Promo() {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 On charge les promos depuis l'API
  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const res = await fetch('/api/promotions.php?action=all');
        const data = await res.json();
        setPromos(data);
      } catch (err) {
        console.error("Erreur chargement promos:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPromos();
  }, []);

  if (loading) return <p>Chargement des promotions...</p>;

  // 🔹 Calcul du prix promo côté React si nécessaire
  const calculPrixPromo = (promo) => {
    if (promo.type_reduction === "pourcentage") {
      return (promo.prix_normal * (1 - promo.valeur / 100)).toFixed(2);
    } else {
      return (promo.prix_normal - promo.valeur).toFixed(2);
    }
  };

  return (
    <main>
      <section className='header-promo'>
        <h1>Découvrez nos promotions du moment</h1>
      </section>

      <section>
        <div className="promos-grid">
          {promos.length === 0 && <p>Aucune promotion en cours.</p>}

          {promos.map(promo => (
            <Link className="promo-card" to={`/produit/${promo.produit_id}`} key={promo.promo_id}>
              <div className="promo-img-wrapper">
                <span className="promo-badge">
                  {promo.type_reduction === 'pourcentage'
                    ? `-${Math.round(promo.valeur)}%`
                    : `-${promo.valeur % 1 === 0 ? promo.valeur : promo.valeur.toFixed(2)}€`}
                </span>
                <img className='promo-img' src={`/static/media/${promo.produit_image}`} alt={promo.produit_nom} />
              </div>

              <h2>{promo.produit_nom} {promo.gout && `(${promo.gout})`}</h2>
              <p>
                <span className="old-price"> {parseFloat(promo.prix_normal)} €</span> <br/>
                Nouveau prix : {parseFloat(calculPrixPromo(promo))} €
              </p>
              <p>Valable jusqu’au {new Date(promo.date_fin).toLocaleDateString()}</p>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Promo;